import { onMounted, ref } from "vue";
import { obtenerSiteMediaMap } from "@/services/siteMedia/siteMediaService";
import { getSiteMediaFallback } from "@/data/siteMediaFallbacks";

export function useSiteMediaImage(key, fallback = "") {
  const resolvedFallback = fallback || getSiteMediaFallback(key);
  const imageUrl = ref(resolvedFallback);
  const loading = ref(true);

  onMounted(async () => {
    try {
      const media = await obtenerSiteMediaMap();
      imageUrl.value = media[key]?.imageUrl || resolvedFallback;
    } catch (_) {
      imageUrl.value = resolvedFallback;
    } finally {
      loading.value = false;
    }
  });

  return imageUrl;
}

export function useSiteMediaImageState(key, fallback = "") {
  const resolvedFallback = fallback || getSiteMediaFallback(key);
  const imageUrl = ref(resolvedFallback);
  const item = ref(null);
  const loading = ref(true);

  onMounted(async () => {
    try {
      const media = await obtenerSiteMediaMap();
      item.value = media[key] || null;
      imageUrl.value = item.value?.imageUrl || resolvedFallback;
    } catch (_) {
      imageUrl.value = resolvedFallback;
    } finally {
      loading.value = false;
    }
  });

  return { imageUrl, item, loading };
}
